import {
  createSlice
} from '@reduxjs/toolkit';

export const batchId = createSlice({
  name: 'batchId',
  initialState: {
    data: ['beforeFetch']
  },
  reducers: {
    fetchSuccess(state, action) {
      const {
        payload
      } = action;
      state.data = payload;
    },
  },
}).reducer;